import * as System from "./System/index.js";
import * as SocialMedia from "./SocialMedia/index.js";
import * as Category from "./Category/index.js";
import * as RealEstate from "./RealEstate/index.js";
import * as Autos from "./Autos";
import * as Flagship from "./Flagship";
export { System, SocialMedia, Category, RealEstate, Autos, Flagship };
export default {
  System: System,
  SocialMedia: SocialMedia,
  Category: Category,
  RealEstate: RealEstate,
  Autos: Autos,
  Flagship: Flagship
};